<form name="setup">
    <table class="table table-hover">
        <thead>
            <tr>
                <th>{{ 'First name' | translate }}</th>
                <th>{{ 'Last name' | translate }}</th>
                <th>{{ 'Email' | translate }}</th>
                <th>{{ 'Password' | translate }}</th>
                <th>{{ 'Is admin' | translate }}</th>
                <th *ngIf="data?.format === 'enhanced'">{{ 'Domain IDs' | translate }}</th>
                <th *ngIf="data?.format === 'enhanced'">{{ 'Domain Group IDs' | translate }}</th>
            </tr>
        </thead>
        <tbody>
            <ng-container *ngFor="let user of data?.data; let $index = index">
            <tr *ngIf="$index">
                <td>
                    {{ getUserValue(user, selected?.firstNameIndex) }}
                </td>
                <td>
                    {{ getUserValue(user, selected?.lastNameIndex) }}
                </td>
                <td>
                    {{ getUserValue(user, selected?.emailIndex) }}
                </td>
                <td>
                    <span *ngIf="getUserValue(user, selected?.passwordIndex)">
                        {{ getUserValue(user, selected?.passwordIndex) }}
                    </span>
                    <span *ngIf="!getUserValue(user, selected?.passwordIndex)">
                        {{ 'Auto generated' | translate }}
                    </span>
                </td>
                <td>
                    <span *ngIf="isAdmin(user)">
                        <span class="fal fa-check"></span>
                    </span>
                    <span *ngIf="!isAdmin(user)">
                        -
                    </span>
                </td>
                <td *ngIf="data?.format === 'enhanced'">
                    <span *ngIf="getUserValue(user, selected?.domainIdsColumnIndex); else noDomainIds">
                        {{ getUserValue(user, selected?.domainIdsColumnIndex) }}
                    </span>
                    <ng-template #noDomainIds>
                        <span class="text-muted">-</span>
                    </ng-template>
                </td>
                <td *ngIf="data?.format === 'enhanced'">
                    <span *ngIf="getUserValue(user, selected?.domainGroupIdsColumnIndex); else noDomainGroupIds">
                        {{ getUserValue(user, selected?.domainGroupIdsColumnIndex) }}
                    </span>
                    <ng-template #noDomainGroupIds>
                        <span class="text-muted">-</span>
                    </ng-template>
                </td>
            </tr>
        </ng-container>
        </tbody>
    </table>
</form>
